import { useEffect } from 'react';

function Chatbot() {
    useEffect(() => {
        const chatbotContainer = document.getElementById('chatbot-container');
        if (window.ChatbotWidget && chatbotContainer) {
            window.ChatbotWidget.init({
                endpoint: 'https://activa-chatbot-prod.azurewebsites.net/webhook',
                container: document.getElementById('chatbot-container'),
                language: 'FR',
                country: 'Congo',
                app: 'Acare',
                theme: {
                    primary: '#2E67D3',
                    secondary: '#F0F7FF',
                    text: '#333333',
                    background: '#FFFFFF'
                },
                // avatarUrl: 'chemin/vers/avatar.jpg'
            });
        } else {
            console.error("Le ChatbotWidget n'est pas chargé.");
        }
    }, []);

    return <div id="chatbot-container"></div>;
}

export default Chatbot;